import {
  AccountUserType,
  Organization as AtlasOrganization,
  OrganizationAccount,
} from '__generated__/atlas-types'

export const UsersTableColumns = {
  Selection: 'selection',
  Email: 'email',
  SalesRepName: 'salesRepName',
  UserType: 'userType',
  LastLogin: 'lastLogin',
  Status: 'status',
  Actions: 'actions',
  DataPermissionConfiguration: 'dataPermissionConfiguration',
  Regions: 'regions',
  // Extra columns that will be hidden for CSV export
  DisplayName: 'displayName',
  DisplayCode: 'displayCode',
  LastAdded: 'lastAdded',
  DateRemoved: 'dateRemoved',
  RegionsCSVExport: 'regionsCSVExport',
} as const

export type UserTableRowData = {
  [UsersTableColumns.Email]: string
  [UsersTableColumns.UserType]: AccountUserType
  [UsersTableColumns.LastLogin]: string
  [UsersTableColumns.Status]: string
  [UsersTableColumns.Regions]: string
  // Hidden columns for CSV export
  [UsersTableColumns.DisplayName]: string
  [UsersTableColumns.DisplayCode]: string
  [UsersTableColumns.LastAdded]: string
  [UsersTableColumns.DateRemoved]: string
  // General user Data needed for actions
  id: string
  accountUserId: string
  created: string
  updated: string
  orderCC: string
  numberConnections: number
  dataPermissionConfiguration: string
}

export type FilterOption = {
  label: string
  value: string
  key: keyof UserTableRowData
  id?: string
}

export type ModalHandlers = {
  isUpsertModalOpen: boolean
  isAddNewUser: boolean
  isOrderEmailsModalOpen: boolean
  isStatusModalOpen: boolean
  isDisabling: boolean
  isComingFromActivation: boolean
  isBulkCopyPermissionsModalOpen: boolean
}

export const STATUS_ACTION_TYPES = {
  ACTIVATE: 'ACTIVATE',
  BULK_ACTIVATE: 'BULK_ACTIVATE',
  DEACTIVATE: 'DEACTIVATE',
  BULK_DEACTIVATE: 'BULK_DEACTIVATE',
} as const

export type Organization = Omit<
  NonNullable<AtlasOrganization>,
  'accountOrganizations'
> & {
  accounts: OrganizationAccount[]
}
